export default (packageName) =>
  new Promise((resolve, reject) => {
    if (window?.hasLoaded?.packages?.[packageName]) {
      resolve();
    } else {
      if (!window?.isLoading?.packages?.[packageName]) {
        document.dispatchEvent(new CustomEvent('package:load', { detail: { name: packageName } }));
      }

      document.addEventListener(`package:loaded:${packageName}`, resolve, { once: true });
      document.addEventListener(`package:failed:${packageName}`, reject, { once: true });
    }
  });
